import { render } from "./EngineeringWorkBench.vue?vue&type=template&id=6d773874"
import script from "./EngineeringWorkBench.vue?vue&type=script&lang=js"
export * from "./EngineeringWorkBench.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__